import React, { useState, useEffect } from 'react';
import { Button, Flex } from 'antd';
import { MedicineBoxOutlined, SearchOutlined } from '@ant-design/icons';
import { useNavigate, Link } from 'react-router-dom';
import miruLogo from '../assets/miru-logo.png';

const NAV_LINKS = [
  { label: 'About ABHA', href: '/#about' },
  { label: 'How to Create', href: '/#how-to' },
  { label: 'Benefits', href: '/#benefits' },
  { label: 'FAQ', href: '/#faq' },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handler);
    return () => window.removeEventListener('scroll', handler);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 bg-white transition-shadow duration-300 ${
        scrolled ? 'navbar-scrolled' : ''
      }`}
      style={{ borderBottom: '1px solid #f0eeff' }}
    >
      <Flex
        align="center"
        justify="space-between"
        className="max-w-7xl mx-auto px-6"
        style={{ height: 70 }}
      >
        {/* Logo only */}
        <Link to="/" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
          <img src={miruLogo} alt="MiRu" style={{ height: 108, objectFit: 'contain', width: 'auto', maxWidth: '100%' }} />
        </Link>

        {/* Nav links – hidden on small screens */}
        <Flex gap={32} align="center" className="hidden md:flex">
          {NAV_LINKS.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="text-sm font-medium transition-colors duration-200"
              style={{ color: '#4a4a6a', textDecoration: 'none' }}
              onMouseEnter={(e) => (e.target.style.color = '#6B35D4')}
              onMouseLeave={(e) => (e.target.style.color = '#4a4a6a')}
            >
              {link.label}
            </a>
          ))}
        </Flex>

        {/* CTA */}
        <Flex gap={12}>
          <Button
            type="text"
            icon={<SearchOutlined />}
            onClick={() => navigate('/fetch-abha')}
            style={{ fontWeight: 600, color: '#6B35D4' }}
          >
            <span className="hidden sm:inline">Find ABHA</span>
          </Button>
          <Button
            type="primary"
            size="large"
            icon={<MedicineBoxOutlined />}
            onClick={() => navigate('/create-abha')}
            style={{
              background: 'linear-gradient(135deg, #6B35D4 0%, #8B55F4 100%)',
              border: 'none',
              fontWeight: 600,
              borderRadius: 10,
              height: 42,
              paddingInline: 24,
              boxShadow: '0 4px 16px rgba(107, 53, 212, 0.35)',
            }}
          >
            Create ABHA
          </Button>
        </Flex>
      </Flex>
    </header>
  );
};

export default Navbar;
